(function () {
    'use strict';

    angular.module('swif.ui')
    .controller('SwifSmsModalController', SwifSmsModalController);


    function SwifSmsModalController($scope, $q, swif, settingsService) {
        'ngInject';
        console.log('init SwifSmsModalController');

        $scope.user = swif.user.getAuthenticatedUserData();

        $scope.isPartner = _.contains($scope.user.access_rights, 'PRES');
        $scope.isTech = _.contains($scope.user.access_rights, 'OFFI');
        $scope.isManagerOrSupervisor = _.contains($scope.user.access_rights, 'MANA') ||
        _.contains($scope.user.access_rights, 'RCPT') ||
        _.contains($scope.user.access_rights, 'ELU');

        var model = settingsService.getContentType($scope.model._type).model;
        var model_id;

        $scope.smsFeature = settingsService.app.features.sms;
        $scope.mode = { write: false };
        $scope.encoding = '7bit';

        $scope.filters = {
            partner_address: { fields: ['id', 'phone_contact_format', 'is_active', 'mobile'] },
            ir_model: { fields: ['id', 'model'] },
            sms_template: {}
        };

        // Set default filters used from widget components
        swif.data.addFilter($scope.filters.partner_address, 'mobile', '!=', false);
        swif.data.addFilter($scope.filters.partner_address, 'mobile', '!=', '');
        swif.data.sortOn($scope.filters.sms_template, 'sequence', 'ASC');
        swif.data.addFilter($scope.filters.sms_template, 'model', '=', model);

        $scope.allowWriteMode = function() {
            $scope.mode.write = !$scope.mode.write;
            $scope.model.template_id = undefined;
            $scope.newSms = {
                model_id: model_id,
                content: '',
                model: model,
                res_id: $scope.model.id,
                to_ids: [],
                more_to: [],
            };
        };

        var sendSms = function (m) {
            var context = {};
            var onCreate = function (result) {
                $scope.mode.write = false;
                // Call collection.defaultActionCallback() to add the new item to the collection
                $scope.smsList.callback(null, {
                    action: {id: 'add'},
                    result: result,
                    model: m
                });
                $scope.smsList.setCurrent(m);
                return swif.sms.send(result.result).then(function () {
                    return result;
                });
            };
            var onSent = function (result) {
                swif.message.addInfo('message envoyé');
                $scope.smsList.updateItem(m);
                return result;
            };
            return swif.sms.createSms(m, context)
            .then(onCreate)
            .then(onSent);
        };

        $scope.sendNewSms = function () {
            var sms = angular.copy($scope.newSms);
            sms.state = 'ready';
            sms.from = $scope.user.complete_name || $scope.user.name;
            sms.encoding = $scope.encoding === 'latin' ? '7bit' : 'unicode';

            // Retrieve numbers phone by user id
            var searchPartnerMobile = function (ids) {
                var filter = {};
                swif.data.addFilter(filter, 'id', 'in', ids);
                filter.fields = ['id', 'phone_contact_format', 'mobile'];
                return swif.data.searchRead('partner_address', filter);
            };

            // Converts array of phone numbers to string of phones separated by comas
            // Trim the value cause ui-select 'tagging-label' attribut adds whitespaces
            var more_phones = sms.more_to.map( phones => phones.trim()).join();

            // If the user select phones form the select dropdown, search mobiles phone from partner ids
            if (!_.isEmpty(sms.to_ids)) {
                searchPartnerMobile(sms.to_ids).then(partner => {
                    // String of number phones used by the back-end to send SMS
                    sms.to = partner.records.map(p => p.mobile).join(',');
                    // String used to display values in the view
                    sms.formatted_to = partner.records.map(p => p.phone_contact_format).join(',');
                    return sms;
                })
                // Concatenate mobiles from the dropdown list with those from the free field
                .then( formattedSms => {
                    formattedSms.to += (more_phones ? ',' + more_phones : '');
                    formattedSms.formatted_to += (more_phones ? ',' + more_phones : '');
                    sendSms(formattedSms)
                });
            } else {
                sms.to = more_phones;
                sms.formatted_to = more_phones;
                sendSms(sms);
            }
        };

        // Hide SMS inputs after creating a new SMS
        $scope.$watch('smsList.currentItem', function (newV) {
            if (newV) {
                $scope.mode.write = false;
            }
        });

        $scope.$watch('model', function (newV) {
            if (newV) {
                swif.data.addFilter($scope.filters.ir_model, 'model', "=", model);
                swif.data.get('model', undefined, $scope.filters.ir_model).then(function (response) {
                    model_id = [response[0].id];
                    $scope.newSms = {
                        model: model,
                        model_id: model_id,
                        res_id: newV.id,
                        from: $scope.user.mobile || ''
                    };

                    swif.sms.createSmsCollection('sms_message', newV)
                    .then(function (collection) {
                        $scope.smsList = collection;
                        // Hide current sms previsualisation when entering the modal
                        $scope.smsList.currentItem = undefined;
                    });
                });
            }
        });

        $scope.loadModel = function(value) {
            var params = {
                fields: ['name', 'content', 'to'],
                domain: [
                    ['id', '=', value.id]
                ]
            };

            // From a template id, fill the multiple select with the right mobile format
            swif.data.searchRead('sms_template', params).then(function (template) {
                if(template.records.length) {
                    params.fields.forEach(renderField);

                    function renderField(fieldName) {
                        let templateValue = template.records[0][fieldName] || '';

                        // Render the template according to the context (current model name & current item id)
                        if(templateValue) {
                            swif.data.callKw(
                                'sms_template',
                                'render_template',
                                [templateValue, model, $scope.newSms.res_id]
                            ).then(function (renderedValue) {
                                if(fieldName === 'to' && renderedValue) {
                                    // With the rendered number phone, search the user id and pass it to the select-multiple
                                    var mobiles = renderedValue.split(',');
                                    var filter = {};
                                    swif.data.addFilter(filter, 'mobile', 'in', mobiles);
                                    filter.fields = ['id', 'phone_contact_format', 'mobile'];
                                    swif.data.searchRead('partner_address', filter).then(function (phones) {
                                        // Update scope to trigger searchRead call from html directive
                                        $scope.newSms.to_ids = phones.ids;
                                    });
                                } else {
                                    $scope.newSms[fieldName] = renderedValue;
                                }
                            });
                        }
                    }
                }
            });
        };
    }
})();
